import { UseQueryOptions } from '@tanstack/react-query';
import { Segment } from 'domains/segments/types';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useSegment = (segmentId: number, reactQueryOptions?: UseQueryOptions<Segment, Error>) =>
    useQuery(QueryKeys.SEGMENT_ID(segmentId), new PathWithID(CuredApiPaths.SEGMENTS, segmentId), reactQueryOptions);

export default useSegment;
